import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { UserEntity } from "../user/user.entity";
import { WelfareEntity } from "../welfare/welfare.entity";
@Entity('welfarestatus')
export class WelfareStatusEntity{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    Id:number;
  @Column("int",{
    nullable: true,
    name:"welfare_id"
  })
  welfareId:number;
  @Column({
    type: 'int',
    nullable:true,
    name: 'user_id'
})
userId: number;
    @Column("varchar",{
        nullable:true,
        length:45,
      
        name:"welfareStatus"
    })
    welfareStatus:string;
    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;
      @Column("int", {
        nullable: false,
        name: "created_user"
      })
      createdUser: number | null;
      @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
      })
      updatedAt: Date;
      @Column("int", {
        nullable: true,
        name: "updated_user"
      })
      updatedUser: number | null;
      @VersionColumn({
          default:1,
          name: "version_flag"
      })
      versionFlag: number;

      @OneToOne(() => WelfareEntity, (welfare: WelfareEntity) => welfare.welfarestatus)
      @JoinColumn({ name: 'welfare_id' })
      welfare: WelfareEntity;    
      @ManyToOne(() =>UserEntity,(user:UserEntity)=>user.welfarestatus)
    @JoinColumn({name:"user_id"})
    user:UserEntity;  
}